import { Tag } from "@bfc-software/pallet";
import { TFunction } from "i18next";
import { DetailField } from "@bfc-software/bfc-web-ui/ui/shared/task-requirements";

import type { LoadLocation } from "./types";
import styles from "./shared.module.css";

export function LoadLocationCard({
  loc,
  t,
}: {
  loc: LoadLocation;
  t: TFunction;
}) {
  const isPositioned = loc.type === "POSITIONED";
  return (
    <div className={styles.loadLocationCard}>
      <Tag
        label={loc.type}
        display={{
          tone: isPositioned ? "info" : "warning",
        }}
      />
      <div className={styles.loadLocationFields}>
        <DetailField
          label={t("page.taskDetail.loadLocation.container")}
          value={loc.container_id}
        />
        <DetailField
          label={t("page.taskDetail.loadLocation.position")}
          value={loc.display_position}
        />
        {isPositioned && (
          <>
            <DetailField
              label={t("page.taskDetail.loadLocation.row")}
              value={loc.row}
            />
            <DetailField
              label={t("page.taskDetail.loadLocation.column")}
              value={loc.column}
            />
            <DetailField
              label={t("page.taskDetail.loadLocation.stack")}
              value={loc.stack_position}
            />
          </>
        )}
      </div>
    </div>
  );
}
